/**
 * @file 訓練課程入力規制
 */
'use strict';

/**
 * @classname DisabledTrigger
 * @classdesc 訓練課程入力規制
 */
export default class DisabledTrigger {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-exemption')
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._$e.on('blur', () => this.onBlur());
	};


	/**
	 * blurのコールバック
	 *
	 * @memberof DisabledTrigger
	 * @return {undefined}
	 */
	onBlur() {
		console.log(`${this.constructor.name}.onBlur`);
		const $disabledTarget = $('.disabled_target');
		if (this._$e.val() === '') {
			$disabledTarget.prop('disabled', true);
		} else {
			$disabledTarget.prop('disabled', false);
		}
	};
}
